<script>
import XTable from "@/components/table/XTable.vue";
import { getFirstAndLastDayOfMonth, accAdd } from '@/vue/util/tool'
import {mapGetters} from "vuex";
import {
  communitynameQuery,
  departmentFind,
  employeeQuery,
  queryAllocationStatistics,
  queryCommissionReason,
} from "../../api/manageCenter";
import {queryScaleList} from "@/api/contracManage";

// 业绩提成统计页面
export default {
  name: "commissionPerformance",
  components: {XTable},
  data() {
    // 示例用法
    const date = getFirstAndLastDayOfMonth();
    return {
      param: {
        date: date,
        contractCode: '', // 合同 客源 房源编号
        contractType: '', // 合同类型
        commissionEmployeeId: '', // 佣金人
        shopid: '', // 部门id
        departmentname: '', // 部门名称
        commissionReason: '', // 分佣原因
        residentialAreaName: '', // 小区
        residentialAreaId: '', // 小区
      },
      columns: [
        { label: '日期', prop: 'signDate' },
        { label: '合同编号', render: 'contractCode' },
        { label: '房源地址', prop: 'houseAddr', 'showOverflowTooltip': true },
        { label: '部门', prop: 'shopName', 'showOverflowTooltip': true, width: '200px' },
        { label: '姓名', prop: 'commissionEmployeeName' },
        { label: '分佣比例(%)', prop: 'scale' },
        { label: '分佣原因', prop: 'commissionReason' },
        { label: '提成比例(%)', prop: 'commissionRatio' },
        { label: '实分业绩(元)', prop: 'achievements' },
        { label: '提成业绩(元)', prop: 'commissionMoney' },
      ],
      departmentList: [],
      AllUserList: [],
      userList: [],
      housingData: [],
      departpopshow: false,
      List: [],
      excelName: '业绩提成统计',
      commissionRateType: [], // 分佣原因
    }
  },
  computed: {
    ...mapGetters(['contractType']),
    fields() {
      return this.columns.reduce((obj, column) => {
        obj[column.label] = column.prop || column.render;
        return obj
      }, {})
    }
  },
  methods: {
    getTableData(pages) {
      let date = this.param.date || [];
      if (date.length) {
        date = [
          date[0].toLocaleString().split(' ')[0].replace(/\//g, '-'),
          date[1].toLocaleString().split(' ')[0].replace(/\//g, '-'),
        ]
      }
      return this.$post(queryAllocationStatistics, {
        'page.pageNumber': (pages.current - 1) * pages.size,
        'page.pageSize': pages.size,
        ...this.param,
        date,
      }).then(res => {
        if (res.data && res.data.length) {
          this.List = res.data;
          res.data.push({
            signDate: '合计：',
            achievements: res.data.reduce((t, i) => accAdd(t, i.achievements), 0),
            commissionMoney: res.data.reduce((t, i) => accAdd(t, i.commissionMoney), 0),
          })
        }
        return {
          total: res.total,
          records: res.data,
        }
      })
    },
    reload() {
      this.$refs.table.load(true)
    },
    // 查询部门
    getdepartmentFind() {
      this.$post(departmentFind).then(res => {
        if (res.success) {
          this.departmentList = res.data;
        } else {
          this.$message({
            type: "error",
            message: res.msg
          });
        }
      });
    },
    cellClassName({column}) {
      const property = column.property;
      if (["achievements", 'commissionMoney'].includes(property)) {
        return 'red'
      }
      return '';
    },
    // 合同详情
    gotodetail(row) {
      sessionStorage.setItem("contractId", row.contractId);
      sessionStorage.setItem("concractEmployeeId", row.signerId);
      sessionStorage.setItem("electronictype", row.contractType);
      // sessionStorage.setItem("contractStatus", row.status); // todo
      // sessionStorage.setItem("electronic", row.electtionContractId); // todo
      this.$router.push({ path: "/contractDetails" });
      sessionStorage.setItem("concractFrom", "contracdetails");
    },
    departmentnameClear() {
      this.param.shopid = '';
      this.param.departmentname = '';
      this.userList = [...this.AllUserList];
      this.reload();
    },
    //选择部门
    handleNodeClick(node) {
      this.param.signer = '';
      this.param.shopid = node.id;
      this.param.departmentname = node.name;
      this.departpopshow = false;
      this.reload();
      this.getUserList()
    },
    getUserList() {
      const params = {
        "page.pageNumber": 1,
        "page.pageSize": 1000,
        departmentId: this.param.shopid,
      };
      this.$post(employeeQuery, params).then(res => {
        if (res.success === true) {
          this.userList = res.data;
          if (!this.param.shopid) {
            this.AllUserList = [...res.data]
          }
        }
      });
    },
    getCommissionRateType() {
      this.$post(queryCommissionReason).then(res => {
        if (res.success === true) {
          this.commissionRateType = res.data;
        }
      });
    },
    // 模糊查询小区
    querySearchAsync(queryString, cb) {
      // 查询小区
      let params = {
        name: queryString,
      };
      this.$post(communitynameQuery, params).then((res) => {
        if (res.success) {
          this.housingData = res.data;
          let restaurants = this.housingData;
          cb(restaurants);
        }
      });
    },
    handleSelect(item) {
      this.param.residentialAreaId = item.residentialAreaId + '';
      this.param.residentialAreaName = item.name;
      this.reload()
    },
    clearArea() {
      this.param.residentialAreaId = '';
      this.param.residentialAreaName = '';
      this.reload()
    },
  },
  mounted() {
    this.getUserList();
    this.getdepartmentFind();
    this.getCommissionRateType();
  },
}
</script>

<template>
<div class="collectionStatistics">
  <ul class="jobs_list">
    <li class="jobs_item">
      <span class="title-dec">签约日期：</span>
      <el-date-picker
          v-model="param.date"
          @change="reload"
          type="daterange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期">
      </el-date-picker>
    </li>
    <li class="jobs_item">
      <span class="title-dec">合同编号：</span>
      <el-input class="short" @input="reload" placeholder="合同、客源、房源编号" v-model="param.queryCode" size="mini"/>
    </li>
    <li class="jobs_item">
      <span class="title-dec">小区：</span>
      <el-autocomplete
          size="mini"
          popper-class="my-autocomplete"
          v-model="param.residentialAreaName"
          :fetch-suggestions="querySearchAsync"
          placeholder="请输入小区"
          @select="handleSelect"
          @clear="clearArea"
          clearable
      >
        <template slot-scope="{ item }">
          <div class="name">{{ item.name }}</div>
        </template>
      </el-autocomplete>
    </li>

    <li class="jobs_item conditions_list_item">
      <span class="title-dec">签约人：</span>
      <el-input
          v-model="param.departmentname"
          @focus="departpopshow=!departpopshow"
          placeholder="请选择"
          clearable
          @clear="departmentnameClear"
          style="width: 160px;"
          size="mini"
      />
      <div class="departpop" v-show="departpopshow">
        <el-tree
            :default-expand-all="true"
            :data="departmentList"
            :props='{ children: "child"}'
            @node-click="handleNodeClick"
        >
              <span class="custom-tree-node" slot-scope="{data}">
                <div>
                  <img class="tree-icon" v-if="data.labelName==='区'" src="../../assets/icon/quyu.png" alt />
                  <img class="tree-icon" v-if="data.labelName==='店'" src="../../assets/icon/dian.png" alt />
                  <img class="tree-icon" v-if="data.labelName==='组'" src="../../assets/icon/zu.png" alt />
                  <span>{{ data.name }}</span>
                </div>
              </span>
        </el-tree>
      </div>
      <el-select
          v-model="param.commissionEmployeeId"
          placeholder="请选择"
          size="mini"
          class="short"
          @change="reload"
          clearable
      >
        <el-option
            v-for="item in userList"
            :key="item.id"
            :label="item.name"
            :value="item.id">
        </el-option>
      </el-select>
    </li>

    <li class="jobs_item">
      <span class="title-dec">合同类型：</span>
      <el-select class="short" v-model="param.contractType" placeholder="请选择" @change="reload" clearable size="mini">
        <el-option v-for="(item,index) in contractType" :key="index" :label="item.valueDesc" :value="item.value"></el-option>
      </el-select>
    </li>
    <li class="jobs_item">
      <span class="title-dec">分佣原因：</span>
      <el-select class="short" v-model="param.commissionReason" @change="reload" placeholder="请选择" size="mini" clearable>
        <el-option v-for="(item,index) in commissionRateType" :key="index" :label="item" :value="item"></el-option>
      </el-select>
    </li>
    <li style="margin-left: auto;">
      <download-excel class="export-excel-wrapper" :data="List" :fields="fields" :name="excelName">
        <el-button type="primary" style="background:#5E75E6;" size="mini">导出</el-button>
      </download-excel>
    </li>
  </ul>
  <XTable
      class="xtable"
      :data="getTableData"
      :columns="columns"
      ref="table"
      :table="{ headerCellStyle: ()=>'background-color: #F2F4FF', border: true, cellClassName: cellClassName  }"
      :page="{pageSize: 20}"
      showPage
      firstRendder
      show-all-btn
  >
    <template v-slot:contractCode="{row, $index}">
      <span
          style="cursor: pointer;color: #5E75E6"
          @click="gotodetail(row)"
      >
        {{row.contractCode}}
      </span>
    </template>
  </XTable>
</div>
</template>

<style scoped lang="less">
.jobs_list {
  display: flex;
  justify-content: flex-start;
  margin: 15px;
  .jobs_item {
    display: flex;
    align-items: center;
    margin-right: 15px;
    .title-dec {
      white-space: nowrap;
    }
  }
  .short {
    width: 120px;
  }
  .el-input__inner {
    width: 170px;
    height: 30px;
    border-radius: 0;
    border: 1px solid #ccc;
    padding-right: 5px;
  }
  .el-date-editor {
    width: 250px;
  }
  .my-autocomplete {
    width: 120px;
  }
}
.x-table {
  /deep/ .red {
    color: red;
  }
  /deep/ tbody tr:last-child td {
    border: none;
  }
}
.conditions_list_item {
  position: relative;
}
.departpop {
  width: 160px;
  position: absolute;
  left: 64px;
  top: 41px;
  z-index: 10;
  border: 1px solid #eee;
  font-size: 14px;
  .el-tree {
    padding: 5px 0;
    .tree-item {
      display: flex;
      align-items: center;
      img {
        padding-right: 10px;
      }
    }
  }
}
</style>
